import validate from "/var/www/sharun-store/drive/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/var/www/sharun-store/drive/middleware/auth.global.ts";
import i18n_45subdomain_45global from "/var/www/sharun-store/drive/middleware/i18n-subdomain.global.ts";
import manifest_45route_45rule from "/var/www/sharun-store/drive/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  i18n_45subdomain_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}